module.exports = __webpack_public_path__ + "img/lidar.a9674bb2.jpg";